import { Container } from '@codeparva/ui-components-library';
import React, { useState } from 'react';
import { HeroTypes } from '..';
import { LocationTypes } from '../../../../..';
import { useWindowDimensions } from '../../../../../utilities/Dimensions';
import { BackgroundHero } from '../components/BackgroundHero';
import { FacilityContainer } from '../components/facilityDetailsVariants/FacilityContainer';
import { Map } from '../components/Map';
import useWindowProperty from '../../../../../utilities/useWindowProperty';

export const HeroSection3 = ({
  sectionHeader,
  media,
  locationDetails,
  headHeight,
  photos,
}: HeroTypes.ILocationHero) => {
  const [updatedLocationDetails, setUpdatedLocationDetails] = useState<
    LocationTypes.ILocationMap
  >(locationDetails);
  const [showModalMap, setShowModalMap] = React.useState(false);
  const [close, setClose] = useState(false);
  const setShowModalMapLocation = () => {
    setClose(true);
    setShowModalMap(!showModalMap);
  };
  const ModalData = {
    showModalMap,
    setShowModalMapLocation,
    locationDetails,
    setUpdatedLocationDetails,
  };
  const scrollYPixels = useWindowProperty('scrollY');
  React.useEffect(() => {
    if (showModalMap) {
      document.body.style.overflowY = 'hidden';
      document.body.style.position = 'fixed';
      document.body.style.width = '100%';
      document.body.style.top = `-${scrollYPixels}px`;
    } else {
      if (close) {
        const scrollY = document.body.style.top;
        document.body.style.overflowY = '';
        document.body.style.position = '';
        document.body.style.top = '';
        window.scrollTo(0, parseInt(scrollY || '0') * -1);
        setClose(false);
      }
    }
  }, [scrollYPixels, showModalMap]);
  const { width } = useWindowDimensions();
  const JumbotronHeight = (width * 6) / 16;
  const height = width >= 1408 ? JumbotronHeight : headHeight;

  return (
    <>
      <DisplayModalMap {...ModalData} />
      <BackgroundHero
        media={media}
        locationMapConfig={locationDetails}
        headHeight={height}
        variant="hero-section-3"
        sectionHeader={sectionHeader}
        setShowModalMapLocation={setShowModalMapLocation}
      />
      <Container className="facilityContainerHeroSection is-fullwidth">
        <FacilityContainer location={updatedLocationDetails} photos={photos} />
      </Container>
    </>
  );
};

export const DisplayModalMap = ({
  showModalMap,
  setShowModalMapLocation,
  locationDetails,
  setUpdatedLocationDetails,
}: any) => {
  return (
    <div className={`modal ${showModalMap && 'is-active'}`}>
      <div className="modal-background"></div>
      <div className="modal-card">
        <div className="modal-card-body">
          <div className="mapModalBody">
            <button
              className="delete is-large"
              onClick={() => {
                setShowModalMapLocation();
              }}
            ></button>
          </div>
          <div>
            <Map
              {...locationDetails}
              onLocationsUpdated={setUpdatedLocationDetails}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
